


















































































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { IMerchantBody, IOrganizations, PayloadState } from '@/types/types';

@Component({ name: 'CreateMerchantDialog' })
export default class CreateMerchantDialog extends Vue {
  @Prop({ required: true, default: false }) state!: boolean;
  @Prop({ default: false }) loading!: boolean;
  @Prop({ default: () => [] }) organizations!: IOrganizations[];

  valid: boolean = false;
  showSecret: boolean = false;
  form: IMerchantBody = this.emptyForm();

  rules = {
    required: (value: string) => !!value || 'This field is required',
    minLength: (value: string) => (value || '').length >= 12 || 'Use at least 12 characters',
  };

  emptyForm(): IMerchantBody {
    return {
      username: '',
      password: '',
      isActive: true,
      additionalCharges: 0,
      organizationId: undefined,
    };
  }

  // Generated in the browser so a human never has to invent a shared secret.
  generateSecret(): void {
    const alphabet = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789';
    const bytes = new Uint32Array(24);
    window.crypto.getRandomValues(bytes);
    this.form.password = Array.from(bytes)
      .map(byte => alphabet[byte % alphabet.length])
      .join('');
    this.showSecret = true;
  }

  @Watch('state')
  onStateChange(open: boolean): void {
    if (!open) return;
    this.form = this.emptyForm();
    this.showSecret = false;
    (this.$refs.form as Vue & { resetValidation: () => void })?.resetValidation();
  }

  @Emit('actions')
  close(payload: PayloadState) {
    return payload;
  }

  @Emit('save')
  save(): IMerchantBody {
    return {
      ...this.form,
      additionalCharges: Number(this.form.additionalCharges) || 0,
      organizationId: this.form.organizationId || undefined,
    };
  }
}
